// extracted by mini-css-extract-plugin
export default {"menuItem":"gznhNXHSTU6jg_8wJHf8"};